import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { PhoneNumberClient, RecordingClient } from '../../api/server';
import { DatePicker } from '@mui/x-date-pickers';
import { ExtendedClient } from '../../api/ExtendedClient';

export default function Recordings({recordingType}) {
    const [voicemails, setVoicemails] = useState([])
    const globalInfo = useSelector((state) => state.globalInfo)
    const [phoneNumbers, setPhoneNumbers] = React.useState([])
    const [currentPhoneNumberId, setCurrentPhoneNumberId] = React.useState("")
    const [startDate, setStartDate] = React.useState(null);
    const [endDate, setEndDate] = React.useState(null);


    function deleteRecording(recordingId) {
        const client = (new ExtendedClient(RecordingClient)).getClient();

        client.deleteVoicemail(recordingId).then((data) => {
            reload()
        })

    }

    function getCurrentPhoneNumberId(){

        const client2 = (new ExtendedClient(PhoneNumberClient)).getClient();

        client2.getPhoneNumbers(globalInfo.currentCompanyId).then((data) => {
            setPhoneNumbers(data);
            setCurrentPhoneNumberId(data[0].phoneNumberId)

            var dstart = new Date();
            var dend = new Date();


            dstart.setDate(dend.getDate());
            setStartDate(dstart)
            setEndDate(dend)

            setEndDate(new Date(new Date().toDateString()))
            setStartDate(new Date(new Date().toDateString()));

        })
    }

    function reload() {
        const client = (new ExtendedClient(RecordingClient)).getClient();

        client.getVoiceMailsByPhoneNumberIdDate(currentPhoneNumberId, startDate, endDate).then((data) => {
            // client.getVoiceMails(globalInfo.currentCompanyId).then((data) => {
                if(recordingType){
                    var filtered = data.filter((x) => x.recordingType === recordingType);
                    setVoicemails(filtered)
                }
                else{
                    setVoicemails(data)
                }
                
        })
    }

    function convertUTCDateToLocalDate(date) {
        var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
        return newDate;
    }

    useEffect(() => {
        if (process.env.REACT_APP_API_URL && globalInfo.currentCompanyId) {
            if (!currentPhoneNumberId) {
                getCurrentPhoneNumberId();
            }
            else {
                reload();
            }
        }
        // eslint-disable-next-line
    }, [globalInfo, globalInfo.currentCompanyId, currentPhoneNumberId, startDate, endDate, recordingType])

    return (
        <>
            <h1>Recordings</h1>
            {/* <br></br><br></br> */}
            {phoneNumbers.length > 1 && phoneNumbers.map((row) => (
                <span key={row.phoneNumberId}>
                    <>
                        {
                            row.phoneNumberId === currentPhoneNumberId && <>
                                &nbsp; <Button onClick={() => { setCurrentPhoneNumberId(row.phoneNumberId) }} variant="contained" size="small"> <> {(row.phoneNumberDigits)}</></Button> &nbsp; 
                            </>
                        }
                    </>
                    <>{
                        row.phoneNumberId !== currentPhoneNumberId && <>
                            &nbsp; <Button onClick={() => { setCurrentPhoneNumberId(row.phoneNumberId) }} variant="outlined" size="small"><> {(row.phoneNumberDigits)}</></Button> &nbsp; 
                        </>
                    }</>
                </span>
            )
            )}
            <br></br>
            <label>Date: </label> <br />
            <DatePicker onChange={(newValue) =>{ setStartDate(newValue); setEndDate(newValue); }} />
            <br></br><br></br>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell><strong> Date/Time</strong></TableCell>
                            <TableCell><strong>From Number</strong></TableCell>
                            <TableCell><strong>To Number</strong></TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {voicemails.map((row) => (
                            <TableRow
                                key={row.recordingId.toString()}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row">
                                    {/* (new Date(row.createdDateTime)) */}
                                    {convertUTCDateToLocalDate(row.createdDateTime).toDateString()} {(convertUTCDateToLocalDate(row.createdDateTime)).toLocaleTimeString()} <br></br>
                                    <figure style={{ marginLeft: -10 }}>
                                        <audio
                                            controls
                                            src={row.recordingUrl}>
                                            <a href={row.recordingUrl}>
                                                Download audio
                                            </a>
                                        </audio>
                                    </figure>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {row.fromPhoneNumberDigits.getFormattedPhoneNum()}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {(row.toPhoneNumberDigits.getFormattedPhoneNum())}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <Button variant='outlined' onClick={() => deleteRecording(row.recordingId)}>Delete</Button>
                                </TableCell>

                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>)

}
